import { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { userVerify } from '../services/authService';
import { toast } from 'react-toastify';
const VerifyOtpForm = ({ email }) => {
    const [otp, setOtp] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            email: email,
            code: otp,
        };

        try {
            const data = await userVerify(payload);

            if (data.status === 200) {
                toast.success('OTP verified successfully!');
            } else {
                toast.error('OTP verification failed. Please try again.');
            }

            console.log('Verifying OTP for:', email, 'with OTP:', otp);
        } catch (error) {
            console.error('Error during OTP verification:', error);
            const message =
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                'Something went wrong during verification.';
            toast.error(message);
        }
    };

    return (
        <div>
            <h2>Verify OTP</h2>
            <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formOtp" className="mb-3">
                    <Form.Label>Enter OTP sent to {email}</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        required
                    />
                </Form.Group>
                <Button variant="success" type="submit">Verify</Button>
            </Form>
        </div>
    );
};

export default VerifyOtpForm;
